import { __pbUser } from "~/stores/pb-user.store";

import { MAX_WAIT_SUB, SEC_HALF_MS } from "~/composables/config";

export async function waitForPB (): Promise<void> {
	await __pbUser().init();

	function checkPB (
		timeout: NodeJS.Timeout,
		interval: NodeJS.Timeout,
		resolve: (value: void | PromiseLike<void>) => void
	): void {
		if (!__pbUser().isLoading) {
			clearTimeout(timeout);
			clearInterval(interval);
			resolve();
		}
	}

	// wait until __pbUser().isLoading is false, after 5s timeout, try every 100ms
	return new Promise((resolve, reject) => {
		const timeout = setTimeout(() => {
			reject(new Error("PB timeout"));
		}, MAX_WAIT_SUB);

		const interval = setInterval(() => {
			checkPB(timeout, interval, resolve);
		}, SEC_HALF_MS);

		checkPB(timeout, interval, resolve);
	});
}
